if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoRotateInterval = null; // Variable to store the auto-rotate interval

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.startAutoRotate(); // Restart auto-rotation when manually triggered
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.startAutoRotate(); // Restart auto-rotation when manually triggered
        });
      }

      // Start auto-rotation on initialization
      this.startAutoRotate();
    }

    changeSlide(direction) {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if (direction === 'next') {
        this.index++;
        // If it's the last slide, go back to the first slide (continuous loop)
        if (this.index >= this.length) {
          this.index = 0; // Go back to the first slide
        }
      } else if (direction === 'prev') {
        this.index--;
        // If it's the first slide, go to the last slide (continuous loop)
        if (this.index < 0) {
          this.index = this.length - 1; // Go to the last slide
        }
      }

      // Ensure continuous scroll from left to right, no reverse scroll
      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

      // Update button states (for manual control)
      if (this.index === 0) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      } else {
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      }

      if (this.index === this.length - 1) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      }
    }

    // Method to start auto-rotation
    startAutoRotate() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval); // Clear any previous interval
      }
      this.autoRotateInterval = setInterval(() => {
        this.changeSlide('next'); // Automatically change to the next slide (left to right)
      }, 2500); // Rotate every 3 seconds (adjust as needed)
    }

    // Optional method to stop auto-rotation (if needed)
    stopAutoRotate() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval); // Clear the interval
      }
    }

  }

  if (typeof customElements.get('announcement-bar') == 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
